import DataCollectionAnalysisTool from './DataCollectionAnalysisTool'
import ImageZoom from 'react-medium-image-zoom'
import PropTypes from 'prop-types'
import React from 'react'
import ResponsiveTable from '../../../Table/ResponsiveTable.js'
import { convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js'
import { getDozorPlot } from '../../../../api/ispyb.js'
import map from 'lodash/map'

export default class DataCollectionListDataCollectionGroupPanel extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleOnSelect = this.handleOnSelect.bind(this)
  }

  handleClick(dataCollection) {
    this.props.processDataCollection(dataCollection)
  }

  getHeaderStats() {
    return {
      xs: { hidden: true },
      sm: { hidden: true },
      md: { width: '30px', textAlign: 'center' },
      lg: { width: '60px', textAlign: 'center' },
    }
  }

  getColumn(text, dataField, formmater) {
    return {
      text: text,
      dataField: dataField,
      formatExtraData: this,
      formatter: formmater,
    }
  }

  getColumns() {
    return [
      { id: 'dataCollectionId', key: true },
      this.getColumn('Prefix', 'imagePrefix'),
      this.getColumn('Run', 'dataCollectionNumber'),
      this.getColumn('# Images', 'numberOfImages'),
      this.getColumn('Exp. Time', 'exposureTime'),
      this.getColumn('Res.(corner)', 'resolution', function (_, row) {
        return convertToFixed(row.resolution, 1) + ' Å (' + convertToFixed(row.resolutionAtCorner, 1) + 'Å)'
      }),
      this.getColumn('Wavelength', 'wavelength'),
      this.getColumn('Transmission', 'transmission', function (_, row) {
        return row.transmission + ' %'
      }),
      this.getColumn('Folder', 'folder', function () {
        return '-'
      }),
      this.getColumn('Time', 'startTime'),
      this.getColumn('Status', 'runStatus'),
      this.getColumn('Indicators', 'Indicators', function (_, row, __, extraData) {
        return (
          <ImageZoom
            image={{
              style: { width: '40px' },
              src: getDozorPlot(extraData.props.user, extraData.props.proposal, row.dataCollectionId),
            }}
          />
        )
      }),
      this.getColumn('View Results', 'View Result', function () {
        return '-'
      }),
      this.getColumn('Phasing', 'hasPhasing'),
      this.getColumn('Comments', 'comments'),
      this.getColumn('', '', function (_, row, __, extraData) {
        return (
          <DataCollectionAnalysisTool
            jobs={extraData.props.jobs}
            configuration={extraData.props.configuration}
            datacollection={row}
          />
        )
      }),
    ]
  }

  handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      this.props.selectDataCollection(row)
    } else {
      this.props.unselectDataCollection(row)
    }

    return true
  }

  render() {
    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      selected: map(this.props.selectedDataCollections, 'dataCollectionId'),
      onSelect: this.handleOnSelect,
    }

    return (
      <ResponsiveTable
        keyField="dataCollectionId"
        selectRow={selectRow}
        pageOptions={{ sizePerPage: 100 }}
        search={false}
        data={this.props.dataCollections}
        columns={this.getColumns()}
      />
    )
  }
}

DataCollectionListDataCollectionGroupPanel.propTypes = {
  dataCollections: PropTypes.array,
  selectedDataCollections: PropTypes.array,
  processDataCollection: PropTypes.func,
  fetching: PropTypes.bool,
}
